import { styled } from 'linaria/react';

export const InputContainerRow = styled.div<{ direction?: string }>`
  @media (min-width: 768px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
    width: 100%;
  }
  @media (max-width: 767px) {
    display: flex;
    flex-direction: ${props => (props?.direction === 'row' ? 'row' : 'column')};
    gap: 28px;
  }
`;

export const InputContainerColumn = styled.div<{ last?: boolean }>`
  @media (min-width: 768px) {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
`;
